declare const VERSION: string;
declare const GIT_VERSION: string;
declare const COMMITHASH: string;
declare const BRANCH: string;

const _VERSION = '2.50.3';
const _GIT_VERSION = 'y';
const _COMMITHASH = 'z';
const _BRANCH = 'f';

export {_VERSION as VERSION};
export {_GIT_VERSION as GIT_VERSION};
export {_COMMITHASH as COMMITHASH};
export {_BRANCH as BRANCH};



// WEBPACK FOOTER //
// ./src/config/gitConstants.ts